import React, { useState, useEffect } from "react";
import SecondLayout from "../layouts/SecondLayout";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
const VIDEO_ID = "DxEURU7Vx3Q";
const Beauty = () => {
  const [videoAvailable, setVideoAvailable] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => {
        if (prev !== currentLang) return currentLang;
        return prev;
      });
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);

  const translations = {
    en: {
      title: "Shop My Skincare and Beauty Products",
      card1Title: "Arab Countries – Africa and MENA",
      card2Title: "Other Countries Including USA & Europe",
      cardText: "Shop My Skincare and Beauty Products",
    },
    ar: {
      title: "تسوقي منتجاتي للعناية بالبشرة والجمال",
      card1Title: "الدول العربية – أفريقيا والشرق الأوسط",
      card2Title: "دول أخرى بما في ذلك الولايات المتحدة وأوروبا",
      cardText: "تسوقي منتجاتي للعناية بالبشرة والجمال",
    },
  };

  const t = translations[language];
  const directionClass = language === "ar" ? "text-right direction-rtl" : "";

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // run on first load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    // Use thumbnail to detect if video exists
    const img = new Image();
    img.src = `https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`;

    img.onload = () => {
      // If image loads and is not the "not found" placeholder
      if (img.width > 120) {
        setVideoAvailable(true);
      } else {
        setVideoAvailable(false);
        setVideoLoaded(true)
      }
    };

    img.onerror = () => setVideoAvailable(false);
  }, []);


  return (
    <SecondLayout>
      <div className="shop-selector-container">
        {/* Background Video or fallback */}
        {!isMobile && videoAvailable ? (
        <iframe
          className="background-video"
          src={`https://www.youtube.com/embed/${VIDEO_ID}?controls=0&rel=0&playsinline=1&autoplay=1&mute=1&loop=1&playlist=${VIDEO_ID}`}
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          title="Background Video"
           onLoad={() => setVideoLoaded(true)}
        ></iframe>
      ) : (
        <div className="background-fallback" />
      )}

        {/* Overlay Content */}
        <div className={`overlay-content ${directionClass}`}>
          {videoLoaded ? <h2 className="shop-title">{t.title}</h2> : ""}

          <div className={`shop-cards ${videoLoaded ? "animate-cards" : ""}`}>
            <div className="shop-card" onClick={() => navigate("/gcc-product")}>
              <i className="fas fa-shopping-basket fa-2x"></i>
              <h6>{t.card1Title}</h6>
              <p>{t.cardText}</p>
            </div>
            <div
              className="shop-card"
              onClick={() => navigate("/us-europe-countries")}
            >
              <i className="fas fa-shopping-basket fa-2x"></i>
              <h6>{t.card2Title}</h6>
              <p>{t.cardText}</p>
            </div>
          </div>
        </div>
      </div>
    </SecondLayout>
  );
};

export default Beauty;
